import { Helper } from '../../../../classes/helper'
import { useSidewall } from '../../../../hooks/state/useSidewall'
import { Keys } from '../../../../hooks/state/utlility/utils'
import { CachedMeshPhysicalMaterial } from '../../../material/cachedMeshPhysicalMaterial'
import { SideTie } from '../window/side/tie/SideTie'
import { RoundHandle } from './slidingDoor/RoundHandle'
import { ShellHandle } from './slidingDoor/ShellHandle'

import { Window } from './slidingDoor/Window'

export const SlidingDoor = (): JSX.Element => {
  const {
    plankHeight,
    sidwallTyp,
    windowsSideWidth,
    windowsSideTotal,
    spaceBetween,
    sideWall,
    type,
    spaceBetweenY,
    doorHandle,
  } = useSidewall()

  const checkBottomLogSize =
    sidwallTyp.log.depth > (sidwallTyp.glas + 0.005) * windowsSideTotal
      ? sidwallTyp.log.depth
      : (sidwallTyp.glas + 0.005) * windowsSideTotal

  return (
    <group
      key={'SlidingDoorContainer'}
      position={[0, sideWall.hasPlankWall ? plankHeight : 0, 0]}
    >
      {[...Array(windowsSideTotal)].map((_, index, array) => {
        return (
          <group
            key={`group${index}`}
            position={[
              0,
              0,
              type === Keys.Seitenwände.Values.SeitenwandHinten.key ? -0.02 : 0,
            ]}
          >
            {(doorHandle.round || doorHandle.default) && (
              <RoundHandle
                position={[
                  type !== Keys.Seitenwände.Values.SeitenwandRechts.key
                    ? sidwallTyp.glas * (windowsSideTotal - 1)
                    : -sidwallTyp.glas * (windowsSideTotal - 1) -
                      sidwallTyp.glas,
                  spaceBetweenY / 2,
                  spaceBetween / 2 - 0.05,
                ]}
              />
            )}

            {doorHandle.shell && (
              <ShellHandle
                index={index}
                position={[
                  (type === Keys.Seitenwände.Values.SeitenwandLinks.key
                    ? -sidwallTyp.glas
                    : sidwallTyp.glas) * index,
                  spaceBetweenY / 2,
                  spaceBetween / 2 - 0.05 - index * windowsSideWidth,
                ]}
              />
            )}

            {doorHandle.startEnd &&
              (index === 0 || index === windowsSideTotal - 1) && (
                <RoundHandle
                  position={[
                    type !== Keys.Seitenwände.Values.SeitenwandRechts.key
                      ? index
                        ? 0
                        : sidwallTyp.glas * (windowsSideTotal - 1)
                      : index
                      ? -sidwallTyp.glas
                      : -sidwallTyp.glas * (windowsSideTotal - 1) -
                        sidwallTyp.glas,
                    spaceBetweenY / 2,
                    spaceBetween / 2 -
                      0.05 -
                      (index
                        ? windowsSideWidth * (windowsSideTotal - 1) +
                          windowsSideWidth -
                          0.125
                        : 0),
                  ]}
                />
              )}

            <Window
              key={`WindowSlidingDoor${index}`}
              height={spaceBetweenY}
              position={[
                (type === Keys.Seitenwände.Values.SeitenwandLinks.key
                  ? -sidwallTyp.glas
                  : sidwallTyp.glas + 0.0012) * index,
                sidwallTyp.log.width,
                (spaceBetween -
                  windowsSideWidth -
                  (index
                    ? type !== 'seitenwandLinks'
                      ? -0.025
                      : sidwallTyp.log.width
                    : 0)) /
                  2 -
                  index * windowsSideWidth,
              ]}
              frame={false}
            />

            <mesh
              key={`mesh${index}`}
              castShadow={true}
              position={[
                (type === Keys.Seitenwände.Values.SeitenwandLinks.key
                  ? -sidwallTyp.glas / windowsSideTotal
                  : sidwallTyp.glas / windowsSideTotal) * index,
                sidwallTyp.log.width,
                0,
              ]}
              rotation={[
                Helper.convertAngleToRadiant(0),
                Helper.convertAngleToRadiant(90),
                Helper.convertAngleToRadiant(0),
              ]}
            >
              <boxGeometry
                args={[
                  spaceBetween - sidwallTyp.glas / 2,
                  0.00835,
                  sidwallTyp.glas,
                ]}
              />
              <CachedMeshPhysicalMaterial color={'silver'} metalness={0.9} />
            </mesh>
          </group>
        )
      })}

      {[...Array(2)].map((_, index) => {
        return (
          <SideTie
            size={[checkBottomLogSize, sidwallTyp.log.width, spaceBetween]}
            rotation={[0, 0, 0]}
            key={`SideTieHorizontal${index}`}
            position={[
              0,
              index ? spaceBetweenY : sidwallTyp?.log?.width / 2,
              0,
            ]}
          />
        )
      })}

      {[...Array(2)].map((_, index) => {
        return (
          <SideTie
            size={[sidwallTyp.log.depth, spaceBetweenY, sidwallTyp.log.width]}
            rotation={[0, 0, 0]}
            key={`SideTieVertical${index}`}
            position={[
              0,
              spaceBetweenY / 2,
              index
                ? spaceBetween / 2
                : (-spaceBetween + sidwallTyp.log.width) / 2,
            ]}
          />
        )
      })}
    </group>
  )
}
